export type SubscribeBackInStockProps = {
	variantId: string;
	email: string;
};

export default async function subscribeBackInStock(props: SubscribeBackInStockProps) {
	try {
		return await fetch('/api/suscribe-back-in-stock', {
			method: 'POST',
			headers: { 'accept': 'application/json', 'content-type': 'application/json' },
			body: JSON.stringify(props),
		});
	} catch (error) {
		console.error('Error during subscription:', error);
	}
}
